var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M12 24C18.6353 24 24 18.6353 24 12C24 5.36471 18.6353 0 12 0C5.36471 0 0 5.36471 0 12C0 18.6353 5.36471 24 12 24Z",
    fill: "#1C2541"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3294 11.9999L10.3765 14.3293V9.74109L14.3294 11.9999ZM18 14.1176V9.88226C18 9.88226 18 7.83521 15.9529 7.83521H8.04706C8.04706 7.83521 6 7.8352 6 9.88226V14.1176C6 14.1176 6 16.1646 8.04706 16.1646H15.8824C15.9529 16.2352 18 16.2352 18 14.1176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.52e2544097a5fe91814cf759b9c8a4f5.svg";
export { ForwardRef as ReactComponent };